"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultVehicleFactory = exports.defaultVehicleInfoStateFactory = exports.VEHICLE_STATUS = exports.SAFETY_SYSTEM_STATUSES = exports.BatteryChargingStatus = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var vehicle_model_1 = require("./vehicle.model");
var BatteryChargingStatus;
(function (BatteryChargingStatus) {
    BatteryChargingStatus["CONNECTED"] = "CONNECTED";
    BatteryChargingStatus["CHARGING"] = "CHARGING";
    BatteryChargingStatus["NOT_CONNECTED"] = "NOT_CONNECTED";
})(BatteryChargingStatus = exports.BatteryChargingStatus || (exports.BatteryChargingStatus = {}));
var SAFETY_SYSTEM_STATUSES;
(function (SAFETY_SYSTEM_STATUSES) {
    SAFETY_SYSTEM_STATUSES["ACTIVE"] = "ACTIVE";
    SAFETY_SYSTEM_STATUSES["INACTIVE"] = "INACTIVE";
    SAFETY_SYSTEM_STATUSES["ABA_NOT_COMMUNICATING"] = "ABA_NOT_COMMUNICATING";
    SAFETY_SYSTEM_STATUSES["VEHICLE_NOT_COMMUNICATING"] = "VEHICLE_NOT_COMMUNICATING";
    SAFETY_SYSTEM_STATUSES["NOT_EQUIPPED"] = "NOT_EQUIPPED";
})(SAFETY_SYSTEM_STATUSES = exports.SAFETY_SYSTEM_STATUSES || (exports.SAFETY_SYSTEM_STATUSES = {}));
var VEHICLE_STATUS;
(function (VEHICLE_STATUS) {
    VEHICLE_STATUS["CONNECTED"] = "Connected";
    VEHICLE_STATUS["NO_STATUS"] = "NoStatus";
    VEHICLE_STATUS["SERVICE_NOW"] = "ServiceNow";
    VEHICLE_STATUS["SERVICE_SOON"] = "ServiceSoon";
    VEHICLE_STATUS["SERVICE_PM"] = "ServicePM";
    VEHICLE_STATUS["PRE_WIRE"] = "PreWireCtp";
})(VEHICLE_STATUS = exports.VEHICLE_STATUS || (exports.VEHICLE_STATUS = {}));
var defaultVehicleInfoStateFactory = function (config) { return (__assign({ availableCustomTags: [], currentVin: '', isEditingCustomTags: false, isLoading: true, isLoadingCustomTagsChanges: false, isLoadingVehicleMaintenanceInfo: false, vehicleInfoErrors: {}, vehicleInfoes: {}, faultFilters: {
        serviceNow: false,
        serviceSoon: false,
        serviceInfo: false,
        servicePM: false,
    }, dateRange: { startDate: (0, moment_timezone_1.default)().subtract(7, 'days').toISOString(), endDate: (0, moment_timezone_1.default)().toISOString() }, vehicleMaintenanceInfo: {} }, config)); };
exports.defaultVehicleInfoStateFactory = defaultVehicleInfoStateFactory;
/** FACTORIES  */
var defaultVehicleFactory = function (config) { return (__assign({ ctp: null, customTags: [], dcvcVersion: '', engineSerial: null, engineType: null, lastUpdated: null, lastTripEndTs: null, lat: null, lng: null, odometer: null, parameterProfile: null, pkgCEV: false, pkgFuelEconomy: false, pkgFuelSubscription: false, pkgZonarFuelEconomy: false, pkgDCVC: false, pkgSafety: false, pkgSafetyPlus: false, pkgSafetySubscription: false, pkgZonarSafety: false, pkgDota: false, powerTrainType: vehicle_model_1.POWER_TRAIN_TYPE.DIESEL, remoteUpdates: false, systemTags: [], unitId: null, vin: '', customerName: '', tan: '', hasCumminsEngine: false, manufacturingRLUL: false, pkgFuelAnalytics: false }, config)); };
exports.defaultVehicleFactory = defaultVehicleFactory;
